import VariantInterface from "../../Interfaces/VariantInterface";
import ProductInterface from "../../Interfaces/ProductInterface";
import Media from "../../Interfaces/MediaInterface";
import { translations } from "../../Helpers/WindowHelpers";
import { formatMoney, getImageSizes, getSrcSet } from "../../Helpers/WindowHelpers";
import { updateVariantObject, addVariants } from "../../Helpers/FormikUpdateFunctions";
import { useFormikContext } from "formik";
import parse from 'html-react-parser';
interface VariantModalBodyDisplayInterface {
    fieldName: string,
    variant: VariantInterface,
    image: Media,
    step: number,
    product?: ProductInterface,
    disableAdd?: boolean,
    multiselect?: boolean,
    closeModal?: () => void,
}

const VariantModalBodyDisplay = ({ fieldName, image, variant, product, multiselect, step, closeModal, disableAdd }: VariantModalBodyDisplayInterface) => {
    const context = useFormikContext();
    let title = variant.title;
    if(product){
        title = product.has_only_default_variant ? product.title : `${product.title}, ${variant.title}`;
    }
    const description = variant.metafields?.custom?.description ? variant.metafields?.custom?.description : product.description;
    const submit = () => {
        multiselect ? addVariants(fieldName, variant, context, step) : updateVariantObject(fieldName, variant, context, step);
        if (typeof closeModal !== 'undefined')
            closeModal();
    }
    return (<>
        <div className="d--flex flex-column gap-30">
            {image.src &&

                <div className="ratio ratio--16-9 round width--100 mx-auto details-modal-image">
                    <span className="visually-hidden">{image.alt}</span>
                    <img
                        className="d--block ratio__content ratio__content--cover"
                        srcSet={getSrcSet(image.src, [350, 525, 700, 1050])}
                        sizes={getImageSizes('525px', [
                            {
                                screen: 767,
                                view: '350px'
                            }
                        ])}
                        alt={image.alt}
                        loading="lazy"
                    />
                </div>
            }
            <div className="d--flex flex-column gap-8 justify--center width--100">
                {variant.metafields?.custom?.promotion_badge?.name && <div><div className="promotion-badge">{variant.metafields?.custom?.promotion_badge?.name}</div></div>}
                <h3 className="h4 title">{title}</h3>
                <div className="modal-text mt-10">{parse(description ?? '')}</div>
                <div className="d--flex justify--end align-items--baseline gap-20">
                    {parseFloat(variant.price) > 0 &&
                        <div className="d--flex gap-10 text--bold">
                            <span className="modal-price">{formatMoney(variant.price)}</span>
                            {parseFloat(variant.compare_at_price) > parseFloat(variant.price) &&
                                <s className="modal-price">{formatMoney(variant.compare_at_price)}</s>}
                        </div>
                    }
                    {!disableAdd &&
                        <button type="button" className="details-modal-add button button--primary button--xl" onClick={() => submit()}>{translations.quick_add}</button>
                    }
                </div>
            </div>
        </div >
    </>);
}

export default VariantModalBodyDisplay;